export class AppSettings {
    public static JwtToken = 'jwtToken';
    public static User = 'userProperty';
}